var React = require('react');

function Speech (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M10.464 28.085a4 4 0 0 1-6.007-4.811l.523-1.24C3.1 20.245 2 17.981 2 15.5 2 9.403 8.458 5 16 5s14 4.403 14 10.5S23.542 26 16 26c-.81 0-1.612-.05-2.398-.15l-3.138 2.235zM16 23c6.075 0 11-3.358 11-7.5C27 11.358 22.075 8 16 8S5 11.358 5 15.5c0 2.212 1.405 4.2 3.64 5.573l-1.418 3.365a1 1 0 0 0 1.501 1.203l4.143-2.95c.993.201 2.045.309 3.134.309z"}));
}

Speech.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Speech;

Speech.default = Speech;
